import { doc, getDoc, collection, getDocs, query, orderBy } from 'firebase/firestore';
import { db } from '../firebase';

export const getOrgChartTemplate = async () => {
  try {
    const templateRef = doc(db, 'orgChartTemplate', 'default');
    const templateDoc = await getDoc(templateRef);
    
    if (!templateDoc.exists()) {
      throw new Error('Org chart template not found');
    }

    const templateData = templateDoc.data();

    // Get position changes
    const positionChangesRef = collection(templateRef, 'positionChanges');
    const positionQuery = query(positionChangesRef, orderBy('revenueThreshold', 'asc'));
    const positionSnapshot = await getDocs(positionQuery);
    
    const positions = positionSnapshot.docs.map(doc => ({
      id: doc.id,
      ...doc.data()
    }));

    // Get 1099 contractors
    const contractorsRef = collection(templateRef, 'contractors');
    const contractorsSnapshot = await getDocs(contractorsRef);
    
    const contractors = contractorsSnapshot.docs.map(doc => ({
      id: doc.id,
      ...doc.data()
    }));

    // Get revenue per employee data
    const revenuePerEmployeeRef = doc(templateRef, 'revenuePerEmployee', 'default');
    const revenuePerEmployeeDoc = await getDoc(revenuePerEmployeeRef);
    
    const revenuePerEmployee = revenuePerEmployeeDoc.exists() 
      ? revenuePerEmployeeDoc.data() 
      : {
          understaffed: { min: 0, max: 0 },
          rightSized: { min: 0, max: 0 },
          overstaffed: { min: 0, max: 0 }
        };

    return {
      name: templateData.name || 'Organization Chart Template',
      positions,
      contractors,
      revenuePerEmployee
    };
  } catch (error) {
    console.error('Error fetching org chart template:', error);
    throw error;
  }
};

export const getUserRevenue = async (userId) => {
  try {
    const userRef = doc(db, 'users', userId);
    const userDoc = await getDoc(userRef);
    
    if (!userDoc.exists()) {
      return null;
    }

    const userData = userDoc.data();
    return userData.salesData?.revenueData?.current || null;
  } catch (error) {
    console.error('Error fetching user revenue:', error);
    return null;
  }
}; 